import { select } from "d3-selection";

import position from "./position";
import "d3-transition";

export default class Tooltip {
  constructor({ main, opts }) {
    this._ = main;
    const { el, buildTooltipHTML, hoverBlockedRight } = opts;

    // default variables
    this.tooltipContent = el.querySelector(".tooltip");
    this.content = this.tooltipContent.querySelector(".tooltip-content");
    this.close = this.tooltipContent.querySelector(".x-close");
    this.hoverBlockedRight = false;
    this.hoverId = null;

    this.buildHTML = buildTooltipHTML;

    if (hoverBlockedRight === true) {
      this.hoverBlockedRight = hoverBlockedRight;

      if (this._.sizes.isDesktop === true) {
        this.tooltipContent.classList.add("fixed-right");
      }
    }

    if (!this.tooltipContent) {
      createEl.call(this);
    }
    return this;
  }

  createEl() {
    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip");
    el.appendChild(tooltip);
    this.tooltipContent = tooltip;
  }

  mouseleave() {
    this.tooltipContent.classList.remove("active");
    this.hoverId = null;
    if (!this._.sizes.isDesktop) {
      this.tweenHeight(false);
    }
  }

  hover(featureId, featureData, hoveredFeature, e) {
    this.mouseover(e);
    if (featureId !== hoveredFeature.id) {
      this.mouseenter(featureData, featureId);
    }
  }

  mouseover(e) {
    const settings = this._.settings.getSettings();
    if (!this._.sizes.isDesktop) {
    } else {
      if (settings.hoverBlockedRight === false)
        position.call(this, e, this._.el);
    }
  }

  mouseoverBlockedRight() {
    // this function does nothing
    return;
  }

  getHeaderTextColor(d, color) {
    let colorInt = color.replace("#", "");
    const r = parseInt(colorInt.substring(0, 2), 16);
    const g = parseInt(colorInt.substring(2, 4), 16);
    const b = parseInt(colorInt.substring(4, 6), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 150 ? "#333" : "white";
  }

  mouseenter(...d) {
    const buildHTML = this.buildHTML;
    const content = d[0];
    const id = d[1];

    this.tooltipContent.classList.add("active");

    this.content.innerHTML = buildHTML.call(this._, id, content);
    this.tweenHeight.call(this, true);
  }

  addCloseEvent(callback, context) {
    const cross = this.tooltipContent.querySelector(".x-close");
    if (cross) {
      cross.addEventListener("click", callback.bind(context));
    }
  }

  tweenHeight(bool) {
    if (this._.sizes.isDesktop) return;
    const minHeight = 0;

    const topHeight = this.tooltipContent
      .querySelector(".tooltip-content")
      .getBoundingClientRect().height;

    const r = bool ? topHeight : minHeight;

    select(this.tooltipContent)
      .classed("active", bool)
      .transition()
      .duration(400)
      .tween("height", (ev, i, [el], j) => {
        const e = select(this.tooltipContent).node().clientHeight;
        const n = select(el);

        return (t) => {
          n.style("height", e * (1 - t) + r * t + "px");
        };
      });
  }
}
